// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"eo_a bhk_a bhk_x bhk_j bhk_u bhk_bc bhk_qj bhk_vt"};